import type { AccountWarningType } from "@/types/accountApiDef"
import { defineStore } from "pinia"
import { computed } from 'vue'
import { useLoginStore } from "@/stores/login"
import { useLegacyVuexPersistedStore } from "@/stores/legacyVuexPersisted"

export const useAccountWarningsStore = defineStore('accountWarnings', () => {
  const loginStore = useLoginStore()
  const localStorageStore = useLegacyVuexPersistedStore()

  const closedAccountWarnings =  computed({
    get: () => localStorageStore.accountWarnings.closedAccountWarnings_v1,
    set: val => localStorageStore.accountWarnings.closedAccountWarnings_v1 = val,
  })

  // アカウント毎の、閉じたバナー警告を記録する
  const accountWarnings = computed(() => {
    if (!loginStore.currentAccount) return [] 
    const {
      account_warnings,
      account_id,
      service_contract_expired_at,
    } = loginStore.currentAccount

    if (!account_warnings) return [];
    if (account_warnings.length < 1) return [];

    const closedWarnings = closedAccountWarnings.value[account_id] || []

    const activeWarnings = account_warnings.filter((w) => {
      const warningOnceClosed = closedWarnings
        .find(cw =>
        (cw.warning_type === w.warning_type
          && cw.service_contract_expired_at === service_contract_expired_at)
        )
      return !warningOnceClosed // 既に閉じた警告は除く
    })

    return activeWarnings.map((w) => {
      return {
        warning_type: w.warning_type,
        message: w.data.message,
        background_color: w.data.background_color,
        close_button_enabled: w.data.close_button_enabled,
        button_text: w.data.button_text,
        button_action: w.data.button_action,
      }
    })
  })

  const closeAccountWarning = (warningType: AccountWarningType) => {
    if (!loginStore.currentAccount) return
     
    const { account_id, service_contract_expired_at } = loginStore.currentAccount

    const closedWarning = { 
      warning_type: warningType, 
      service_contract_expired_at
    }

    const curClosedWarnings = closedAccountWarnings.value[account_id]

    if (!curClosedWarnings) {
      closedAccountWarnings.value[account_id] = [closedWarning]
    }
    else{
      const newClosedWarnings = [
        closedWarning,
        ...curClosedWarnings
      ]
      closedAccountWarnings.value[account_id] = newClosedWarnings
    }
    closedAccountWarnings.value = Object.assign({}, closedAccountWarnings.value, closedAccountWarnings.value)
  }

  return {
    accountWarnings,
    closeAccountWarning,
  }
})